module.exports = __webpack_public_path__ + "img/tab-message-active.9103f688.png";